import React from 'react';
import IndesicionApp from './components/IndecisionApp';

export default class App extends React.Component {
  render() {
    return (
      <>
        <IndesicionApp />
      </>
    )
  }
}
